module.exports = __webpack_public_path__ + "static/media/external-link-square-alt.13bea4ed.svg";